import moment from "moment/moment";
import { useModal } from "../../hooks/use-modal.jsx";
import { useState } from "react";
import DocumentsFormUpload from "../File/DocumentsFormUpload";
import DocumentCard from "../File/DocumentCard";
import useFiles from "../../hooks/use-files";
import StatusCell from "../Pilotage/StatusCell";
import { FileTag } from "../../utils/constants/documents";
import styles from "../File/DocumentShowList.module.css";

// Les attestations sont « valides », les documents contractuels « signés ».
const ATTESTATION_TAGS = [
  FileTag.ASSURANCE_HABITATION,
  FileTag.ENTRETIEN_CHAUFFAGE,
];

const formatDate = (date) => moment(date).format("DD/MM/YYYY");

function getDisplay({ status, validUntil }, tag) {
  switch (status) {
    case "expire":
      return {
        color: "danger",
        text: "Expiré",
        tooltip: validUntil && `Expiré depuis le ${formatDate(validUntil)}`,
      };
    case "aValider":
      return { color: "info", text: "À valider" };
    case "bientotExpire": {
      const days = moment(validUntil).diff(moment().startOf("day"), "days");
      return {
        color: "warning",
        text: days <= 0 ? "Expire aujourd'hui" : `Expire J-${days}`,
        tooltip: `Valide jusqu'au ${formatDate(validUntil)}`,
      };
    }
    default:
      return {
        color: "success",
        text: ATTESTATION_TAGS.includes(tag) ? "Valide" : "Signé",
        tooltip: validUntil && `Valide jusqu'au ${formatDate(validUntil)}`,
      };
  }
}

export default function CheckDocuments({
  tag,
  files = [],
  tenant,
  state,
  onDocumentSubmitted,
}) {
  const [DocumentModal, closeDocumentModal, openDocumentModal] = useModal();
  const [typeDocument, setTypeDocument] = useState("");
  const {
    deleteFile,
    sendToElectronicSigning,
    updateFile,
    cancelElectronicSigning,
    relanceSignataire,
    sendToLaPoste,
  } = useFiles({});
  async function deleteDocumentHandler(fileId) {
    try {
      await deleteFile(fileId);
    } catch (error) {
      console.error(error);
    }
  }
  const open = () => {
    setTypeDocument(tag);
    openDocumentModal();
  };
  const display = state.status === "absent" ? null : getDisplay(state, tag);
  return (
    <>
      <DocumentModal size={"big"}>
        {files?.filter((file) => file.tag === tag).length <= 1 ? (
          <DocumentsFormUpload
            tenant={tenant}
            onSubmitted={() => {
              if (onDocumentSubmitted) onDocumentSubmitted();
              closeDocumentModal();
            }}
            isBailleur
            typeDocument={typeDocument}
            file={files?.find((file) => file.tag === tag)}
          />
        ) : (
          <div className={styles.grid}>
            {files
              ?.filter((file) => file.tag === tag)
              .map((file, i) => (
                <DocumentCard
                  titre={file.filename}
                  files={[file]}
                  type={tag}
                  key={i}
                  deleteDocumentHandler={deleteDocumentHandler}
                  isBailleur
                  tenant={tenant}
                  updateFile={updateFile}
                  sendToElectronicSigning={
                    document.tag !== "caution"
                      ? sendToElectronicSigning
                      : undefined
                  }
                  sendToLaPoste={sendToLaPoste}
                  cancelElectronicSigning={cancelElectronicSigning}
                  relanceSignataire={relanceSignataire}
                  allowEdit
                />
              ))}
          </div>
        )}
      </DocumentModal>
      {display ? (
        <StatusCell
          variant="badge"
          color={display.color}
          text={display.text}
          tooltip={display.tooltip || undefined}
          onClick={open}
        />
      ) : (
        <StatusCell variant="add" onClick={open} />
      )}
    </>
  );
}
